module.exports = __webpack_public_path__ + "static/media/openaire.6a79a6bc.png";